<template>
  <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8 lg:gap-x-16">
    <div
      v-for="benefit in benefits"
      :key="benefit.icon"
      class="flex items-center gap-4"
    >
      <TIcon
        :icon="['fal', benefit.icon]"
        size="2xl"
        fixed-width
      />
      <span class="text-gray-500">{{ benefit.name }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IconName } from '@fortawesome/fontawesome-svg-core'

const { t } = useI18n()
const benefits = computed<{ name: string, icon: IconName }[]>(() => [
  {
    name: t('coverage'),
    icon: 'shield-check',
  },
  {
    name: t('support'),
    icon: 'headset',
  },
  {
    name: t('verified'),
    icon: 'circle-check',
  },
  {
    name: t('roadside'),
    icon: 'truck-tow',
  },
])
</script>

<i18n lang="json">
{
  "en": {
    "coverage": "Insurance coverage included on every trip",
    "support": "Top-rated support to help you in real-time",
    "verified": "Verified RVs that can be picked up or delivered",
    "roadside": "24/7 roadside assistance available on every rental"
  },
  "fr": {
    "coverage": "Couverture d’assurance durant chaque voyage",
    "support": "Support bilingue pour vous aider en temps réel",
    "verified": "Récupéréz ou livrez le VR à destination",
    "roadside": "Assistance routière 24/7 disponible pour chaque location"
  }
}
</i18n>
